<template>
  <v-select :label="label" :hideDetails="hideDetails" :items="items" @focus="showSave = true">
    <template slot="append-outer">
      <v-icon color="info" v-if="showSave" @click.prevent.stop="save()">
        save
      </v-icon>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "SelectSave",

  props: {
    label: {
      type: String,
      default: "",
    },

    hideDetails: {
      type: Boolean,
      default: false,
    },

    items: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    showSave: false,
  }),

  methods: {
    save() {
      alert("SAVE!");
      this.showSave = false;
    },
  },
};
</script>

<style scoped></style>
